import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { getMultilineTruncation } from '../../../../../play-core/styles/style-helper';
import { useElementSize } from '../../../hooks/use-element-size';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowMoreText = ({
  description,
  numberOfLines = 3
}) => {
  const [extended, setExtended] = useState(false);
  const [isExtendable, setIsExtendable] = useState(false);
  const {
    t
  } = useTranslation();
  const ref = React.useRef(null);
  const {
    width
  } = useElementSize(ref);
  useEffect(() => {
    if (ref.current) {
      // When the element width or the number of lines changes, it needs to be check if the text is extendable
      setIsExtendable(ref.current.clientHeight < ref.current.scrollHeight);
      setExtended(false);
    }
  }, [width, numberOfLines]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Description, {
      ref: ref,
      extended: extended,
      numberOfLines: numberOfLines,
      children: description
    }), /*#__PURE__*/_jsx(Fragment, {
      children: isExtendable && /*#__PURE__*/_jsx(ShowMore, {
        "aria-expanded": extended,
        onClick: () => setExtended(prev => !prev),
        children: extended ? t('global.showLess') : t('global.showMore')
      })
    })]
  });
};
const lineHeight = 28;
const ShowMore = styled.button.withConfig({
  displayName: "ShowMoreText__ShowMore",
  componentId: "sc-lhqjav-0"
})(["", ";line-height:", "px;padding:0;color:", ";&:hover{color:", ";}"], Fonts.regular(18), lineHeight, Colors.GREY_e1e1e1, Colors.WHITE);
const Description = styled.p.withConfig({
  displayName: "ShowMoreText__Description",
  componentId: "sc-lhqjav-1"
})(["", ";color:", ";line-height:", "px;margin:0;max-width:900px;", ";white-space:pre-line;"], Fonts.light(18), Colors.GREY_d2d2d2, lineHeight, ({
  extended,
  numberOfLines
}) => !extended && getMultilineTruncation(numberOfLines, lineHeight));